export const testQuestions = {
  questions: [
    {
      id: 10,
      type: 'Information',
      translations: [
        { en: 'Please book your appointment according to the instructions given by your doctor.' },
        { nl: 'Plan your appointment according to your doctor\'s instructions.' }
      ]
    },
    {
      id: 11,
      type: 'Warning',
      translations: [
        {
          en:
            'For this specialty it is not yet possible to book an appointment online. Please contact our reception directly via phone in order to book an appointment. Our phone numbers can be found on this page: https://orthoca.be/contact/afspraak-maken/'
        },
        {
          nl:
            'Voor dit specialisme is het nog niet mogelijk om online een afspraak te maken. Contacteer ons secretariaat rechtstreeks via telefoon om een afspraak te maken. Onze telefoonnummers kan je vinden via deze pagina: https://orthoca.be/contact/afspraak-maken/'
        }
      ]
    },
    {
      id: 12,
      type: 'Information',
      translations: [
        {
          en:
            'Our doctors will need to have an MRI or your knee (both knees if the problem impacts both of your knees). If you don\'t already have an MRI task, then please do this first before meeting with our doctors. Contact your general practitioner for a prescription and MRI appointment. Make sure to set your appointment with our doctors AFTER the MRI has been tasked.'
        },
        {
          nl:
            'Een MRI onderzoek is vermoedelijk nodig om de juiste diagnose te kunnen stellen. Als er nog geen (recent) MRI onderzoek is gedaan, gelieve dit te laten doen voor de afspraak met onze artsen. Contacteer uw huisarts voor een voorschrift en MRI afspraak. Zorg dat de afspraak met onze arts NA uw MRI afspraak wordt gepland.'
        }
      ]
    },
    {
      id: 13,
      type: 'Information',
      translations: [
        {
          en:
            'Our doctors will need to have an X-ray image of your knee (or both knees if the problem impacts both of your knees). If you don\'t already have an X-ray taken, then this can be done at our campus. In that case, please make sure to register at our reception 45 minutes before your appointment with our doctor. Attention: the radiology department closes at 16h30.'
        },
        {
          nl:
            'Onze artsen zullen vermoedelijk een röntgenfoto van je knie (of beide knieën indien relevant) nodig hebben om de correcte diagnose te stellen. Als je nog geen röntgenfoto\'s hebt laten nemen, dan kan je dit laten doen voor de consultatie bij onze arts. Hiervoor dien je je 45 minuten voor je afspraak met onze arts aan te melden bij onze receptie. Opgelet: de dienst radiologie sluit om 16u30.'
        }
      ]
    },
    {
      id: 14,
      type: 'Warning',
      translations: [
        {
          en:
            'Please contact our reception directly via phone in order to book an appointment. We need more information about the injury in order to determine the urgency. Our phone numbers can be found on this page: https://orthoca.be/contact/afspraak-maken/'
        },
        {
          nl:
            'Contacteer ons secretariaat rechtstreeks via telefoon om een afspraak te maken. We hebben meer informatie nodig om de urgentie van de afspraak in te schatten. Onze telefoonnummers kan je vinden via deze pagina: https://orthoca.be/contact/afspraak-maken/'
        }
      ]
    },
    {
      id: 1,
      type: 'Radio',
      position: 1,
      isRequired: true,
      translations: [
        { en: 'Does this concern a follow-up appointment?' },
        { nl: 'Is it a control agreement for a known problem?' }
      ],
      answers: [
        {
          id: 1,
          translations: [
            { en: 'Yes, follow-up appointment' },
            { nl: 'Yes, inspection appointment' }
          ],
          behaviors: [
            { nextQuestionId: 10 },
            { isCompleted: false, nextQuestionId: 2, results: [{ appointmentType: 'follow_up' }] }
          ]
        },
        {
          id: 2,
          translations: [{ en: 'No, new problem' }, { nl: 'No, new issues' }],
          behaviors: [
            { isCompleted: false, nextQuestionId: 3, results: [{ appointmentType: 'new' }] }
          ]
        }
      ]
    },
    {
      id: 2,
      type: 'Select',
      position: 2,
      isRequired: true,
      translations: [
        { en: 'Please select your doctor from the list:' },
        { nl: 'Please select your doctor from the list below:' }
      ],
      answers: [
        {
          id: 1,
          translations: [{ en: 'Prof. Dr. Peter Verdonk' }, { nl: 'Prof. Dr. Peter Verdonk' }],
          behaviors: [
            {
              isCompleted: true,
              results: [{ practitionerIds: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3' }]
            }
          ]
        },
        {
          id: 2,
          translations: [{ en: 'Dr. Roger Van Riet' }, { nl: 'Dr. Roger Van Riet' }],
          behaviors: [
            {
              isCompleted: true,
              results: [{ practitionerIds: 'ddda7b4d-b30c-4d6b-84be-63676935085b' }]
            }
          ]
        }
      ]
    },
    {
      id: 3,
      type: 'Select',
      position: 3,
      isRequired: true,
      translations: [
        { en: 'Please select why you would like to book an appointment:' },
        { nl: 'Select what you want to make an appointment for:' }
      ],
      answers: [
        {
          id: 1,
          translations: [{ nl: 'Knie' }, { en: 'Knee' }],
          behaviors: [
            {
              isCompleted: false,
              nextQuestionId: 4,
              results: [{ specialtyIds: '00f998e8-21e1-466d-8e01-a56c45bb6bad' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 2,
          translations: [{ en: 'Hip' }, { nl: 'Heup' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: '1ad0164e-1b2e-467f-a05b-bf2a31eea1d4' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 3,
          translations: [{ en: 'Shoulder' }, { nl: 'Schouder' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: '34c3ee2e-e02d-43c5-b0b8-00b8b7ab1707' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 4,
          translations: [{ nl: 'Kinderorthopedie' }, { en: 'Children Orthopaedics' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: '48684331-0704-442d-8c14-cf7eba8bc73e' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 5,
          translations: [{ en: 'Elbow' }, { nl: 'Elleboog' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: '4c2f761e-9a5f-40d6-a76e-cb21dbdeb0b0' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 6,
          translations: [{ en: 'Foot & Ankle' }, { nl: 'Voet & Enkel' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: '6dffaf47-96ca-4464-ad5e-4d1c247d1f83' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 7,
          translations: [{ en: 'Trauma' }, { nl: 'Trauma' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: 'b29abf04-7120-44ab-b983-d7557f5235ac' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 8,
          translations: [{ nl: 'Rug & Wervelkolom' }, { en: 'Back & Spine' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: 'bab284de-07b5-421b-bb86-8dcac58987d4' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 9,
          translations: [{ en: 'Sports injuries' }, { nl: 'Sportletsels' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: 'c0c8281f-04b0-45a2-b2f3-dc4ac438ae97' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 10,
          translations: [{ nl: 'Menselijke schade' }, { en: 'Human damage' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: 'd6d7e169-2650-4b25-9b28-b93bb450ebd2' }],
              conditions: 'checkSpecialty'
            }
          ]
        },
        {
          id: 11,
          translations: [{ en: 'Hand & Wrist' }, { nl: 'Hand & Pols' }],
          behaviors: [
            {
              isCompleted: true,
              nextQuestionId: null,
              results: [{ specialtyIds: 'e92d2a49-8708-42e3-93b1-8d708e7cd572' }],
              conditions: 'checkSpecialty'
            }
          ]
        }
      ]
    },
    {
      id: 4,
      type: 'Radio',
      position: 4,
      isRequired: true,
      translations: [
        { en: 'Is this new problem caused by a sports injury or other trauma?' },
        { nl: 'Is this new problem caused by a sports accident or other trauma?' }
      ],
      answers: [
        {
          id: 1,
          translations: [{ en: 'Yes' }, { nl: 'Ja' }],
          behaviors: [{ isCompleted: false, nextQuestionId: 14 }]
        },
        { id: 2, translations: [{ en: 'No' }, { nl: 'Nee' }], behaviors: [{ conditions: 'age' }] }
      ]
    },
    {
      id: 5,
      type: 'Radio',
      position: 5,
      isRequired: true,
      translations: [
        { en: 'Do you have pain in both knees?' },
        { nl: 'Heb je pijn/ last in beide knieën?' }
      ],
      answers: [
        { id: 1, translations: [{ en: 'Yes' }, { nl: 'Ja' }], behaviors: [{ isCompleted: true }] },
        { id: 2, translations: [{ en: 'No' }, { nl: 'Nee' }], behaviors: [{ isCompleted: true }] }
      ]
    }
  ]
};
